// PIX e dinheiro parcelados são "fiado" pra conhecidos: a venda nasce
// Pendente e vira Paga quando todas as parcelas são baixadas no Financeiro
// (botão $ em Vendas). Cartão (parcelado ou não), débito e qualquer coisa
// à vista já entram como Pago.
export const DEFERRED_METHODS = ["pix", "money"];

/** Métodos em que o caixa escolhe o número de parcelas. */
export const INSTALLMENT_METHODS = ["credit_card", "pix", "money"];

export function saleStatusFor(paymentMethod, installments) {
  return DEFERRED_METHODS.includes(paymentMethod) && Number(installments) > 1
    ? "pendent"
    : "paid";
}

/**
 * Status a gravar ao salvar a venda. Na edição, se forma de pagamento e
 * parcelas não mudaram, mantém o status atual — senão uma venda já quitada
 * pelo Financeiro voltaria pra Pendente só por trocar um produto.
 */
export function resolveSaleStatus(order, originalOrder) {
  if (
    originalOrder &&
    originalOrder.status &&
    originalOrder.paymentMethod === order.paymentMethod &&
    Number(originalOrder.installments || 1) === Number(order.installments || 1)
  ) {
    return originalOrder.status;
  }
  return saleStatusFor(order.paymentMethod, order.installments);
}
